export const pageSize = {
    onChangePage: (store, payload) => {
      store.setState({ pageSize: payload });
    },
  };
  